<template>
	<div class="model4">
		<!-- 全球排名变化 -->
		<div class="m4_info_box_big">
			<div class="article_l_title">
				<img class="img1" src="../assets/main/title_icon.jpg" alt="" />
				<span>{{ title1 }}</span>
				<a
					@click="pageOne('/encolumn?id=76&name=能源数据&uid=461')"
					class="article_l_more"
					href="javascript:void(0);"
					>more<img src="../assets/main/more.png" alt=""
				/></a>
			</div>
			<div class="m4_info_echarts_box1" id="m4_info_echarts_box1"></div>
		</div>
		<div class="m4_info_box_big">
			<div class="article_l_title">
				<img class="img1" src="../assets/main/title_icon.jpg" alt="" />
				<span>{{ title2 }}</span>
				<a
					@click="pageOne('/encolumn?id=76&name=能源数据&uid=15')"
					class="article_l_more"
					href="javascript:void(0);"
					>more<img src="../assets/main/more.png" alt=""
				/></a>
			</div>
			<div class="m4_info_echarts_box1" id="m4_info_echarts_box2"></div>
		</div>
		<div class="m4_info_box">
			<!-- 第1列 -->
			<div class="m4_info_box1">
				<div class="article_l_title">
					<img
						class="img1"
						src="../assets/main/title_icon.jpg"
						alt=""
					/>
					<span>{{ title3 }}</span>
					<a
						@click="pageOne('/encolumn?id=76&name=能源数据&uid=21')"
						class="article_l_more"
						href="javascript:void(0);"
						>more<img src="../assets/main/more.png" alt=""
					/></a>
				</div>
				<div
					class="m4_info_echarts_box2"
					id="m4_info_echarts_box3"
				></div>
			</div>
			<div class="m4_info_box2">
				<div class="article_l_title">
					<img
						class="img1"
						src="../assets/main/title_icon.jpg"
						alt=""
					/>
					<span>{{ title4 }}</span>
					<a
						@click="pageOne('/encolumn?id=76&name=能源数据&uid=21')"
						class="article_l_more"
						href="javascript:void(0);"
						>more<img src="../assets/main/more.png" alt=""
					/></a>
				</div>
				<div
					class="m4_info_echarts_box2"
					id="m4_info_echarts_box4"
				></div>
			</div>
			<!-- 第2列 -->
			<div class="m4_info_box1">
				<div class="article_l_title">
					<img
						class="img1"
						src="../assets/main/title_icon.jpg"
						alt=""
					/>
					<span>{{ title5 }}</span>
					<a
						@click="pageOne('/encolumn?id=76&name=能源数据&uid=25')"
						class="article_l_more"
						href="javascript:void(0);"
						>more<img src="../assets/main/more.png" alt=""
					/></a>
				</div>
				<div
					class="m4_info_echarts_box2"
					id="m4_info_echarts_box5"
				></div>
			</div>
			<div class="m4_info_box2">
				<div class="article_l_title">
					<img
						class="img1"
						src="../assets/main/title_icon.jpg"
						alt=""
					/>
					<span>{{ title6 }}</span>
					<a
						@click="pageOne('/encolumn?id=76&name=能源数据&uid=25')"
						class="article_l_more"
						href="javascript:void(0);"
						>more<img src="../assets/main/more.png" alt=""
					/></a>
				</div>
				<div
					class="m4_info_echarts_box2"
					id="m4_info_echarts_box6"
				></div>
			</div>
			<!-- 第3列 -->
			<div class="m4_info_box1">
				<div class="article_l_title">
					<img
						class="img1"
						src="../assets/main/title_icon.jpg"
						alt=""
					/>
					<span>{{ title7 }}</span>
					<a
						@click="pageOne('/encolumn?id=76&name=能源数据&uid=27')"
						class="article_l_more"
						href="javascript:void(0);"
						>more<img src="../assets/main/more.png" alt=""
					/></a>
				</div>
				<div
					class="m4_info_echarts_box2"
					id="m4_info_echarts_box7"
				></div>
			</div>
			<div class="m4_info_box2">
				<div class="article_l_title">
					<img
						class="img1"
						src="../assets/main/title_icon.jpg"
						alt=""
					/>
					<span>{{ title11 }}</span>
					<a
						@click="pageOne('/encolumn?id=76&name=能源数据&uid=37')"
						class="article_l_more"
						href="javascript:void(0);"
						>more<img src="../assets/main/more.png" alt=""
					/></a>
				</div>
				<div
					class="m4_info_echarts_box2"
					id="m4_info_echarts_box11"
				></div>
			</div>

			<!-- 第4列 -->
			<div class="m4_info_box1">
				<div class="article_l_title">
					<img
						class="img1"
						src="../assets/main/title_icon.jpg"
						alt=""
					/>
					<span>{{ title9 }}</span>
					<a
						@click="pageOne('/encolumn?id=76&name=能源数据&uid=34')"
						class="article_l_more"
						href="javascript:void(0);"
						>more<img src="../assets/main/more.png" alt=""
					/></a>
				</div>
				<div
					class="m4_info_echarts_box2"
					id="m4_info_echarts_box9"
				></div>
			</div>
			<div class="m4_info_box2">
				<div class="article_l_title">
					<img
						class="img1"
						src="../assets/main/title_icon.jpg"
						alt=""
					/>
					<span>{{ title10 }}</span>
					<a
						@click="pageOne('/encolumn?id=76&name=能源数据&uid=34')"
						class="article_l_more"
						href="javascript:void(0);"
						>more<img src="../assets/main/more.png" alt=""
					/></a>
				</div>
				<div
					class="m4_info_echarts_box2"
					id="m4_info_echarts_box10"
				></div>
			</div>
			<!-- 第5列 -->
			<div class="m4_info_box1">
				<div class="article_l_title">
					<img
						class="img1"
						src="../assets/main/title_icon.jpg"
						alt=""
					/>
					<span>{{ title8 }}</span>
					<a
						@click="pageOne('/encolumn?id=76&name=能源数据&uid=28')"
						class="article_l_more"
						href="javascript:void(0);"
						>more<img src="../assets/main/more.png" alt=""
					/></a>
				</div>
				<div
					class="m4_info_echarts_box2"
					id="m4_info_echarts_box8"
				></div>
			</div>
			<div class="m4_info_box2">
				<div class="article_l_title">
					<img
						class="img1"
						src="../assets/main/title_icon.jpg"
						alt=""
					/>
					<span>{{ title12 }}</span>
					<a
						@click="pageOne('/encolumn?id=76&name=能源数据&uid=39')"
						class="article_l_more"
						href="javascript:void(0);"
						>more<img src="../assets/main/more.png" alt=""
					/></a>
				</div>
				<div
					class="m4_info_echarts_box2"
					id="m4_info_echarts_box12"
				></div>
			</div>
		</div>
	</div>
</template>
<script>
import api from '@/../static/common/api/api.js';
import magic from '@/../static/common/magic.js';
import $ from 'jquery';
import echarts from 'echarts';

export default {
	// 全国能源数据概览
	props: ['currentChoose'],
	components: {},
	data() {
		return {
			title1: '',
			title2: '',
			title3: '',
			title4: '',
			title5: '',
			title6: '',
			title7: '',
			title8: '',
			title9: '',
			title10: '',
			title11: '',
			title12: '',
		};
	},
	watch: {
		currentChoose(val) {
			// this.fetchDataList(val);//获取文章列表
		},
	},
	mounted() {
		// this.fetchDataList(this.currentChoose);
		this.fetchData1();
		this.fetchData2();
		this.fetchData3();
		this.fetchData4();
		this.fetchData5();
		this.fetchData6();
		this.fetchData7();
		this.fetchData8();
		this.fetchData9();
		this.fetchData10();
		this.fetchData11();
		this.fetchData12();
	},
	methods: {
		pageOne(url) {
			this.$router.push({ path: url });
			window.location.reload();
		},
		//获取数据-全球排名变化
		fetchData1() {
			var chartDom = document.getElementById('m4_info_echarts_box1');
			var myChart = echarts.init(chartDom);
			var option;

			option = {
				dataZoom: [
					{
						start: 70,
						end: 100,
						height: 16,
					},
				],
				color: ['#7D97A8'],
				grid: {
					left: '2%',
					right: '2%',
					bottom: '16%',
					top: '3%',
					containLabel: true,
				},
				tooltip: {
					show: true,
					trigger: 'item',
					formatter: '{b}： {c}',
				},
				xAxis: {
					type: 'category',
					data: ['英国1', '英国2'],
					axisLine: {
						lineStyle: {
							color: '#CCCCCC',
							width: 1, //这里是为了突出显示加上的
						},
					},
					axisLabel: {
						// X轴线 标签修改
						textStyle: {
							color: '#4D4D4D', //坐标值得具体的颜色
						},
					},
					splitLine: {
						show: true, // X轴线 颜色类型的修改
						lineStyle: {
							type: 'dashed',
							color: '#F2F2F2',
						},
					},
				},
				yAxis: {
					type: 'value',
					axisLine: {
						lineStyle: {
							color: '#CCCCCC',
							width: 1, //这里是为了突出显示加上的
						},
					},
					axisLabel: {
						// X轴线 标签修改
						textStyle: {
							color: '#4D4D4D', //坐标值得具体的颜色
						},
					},
					splitLine: {
						show: true, // X轴线 颜色类型的修改
						lineStyle: {
							type: 'dashed',
							color: '#F2F2F2',
						},
					},
				},
				series: [
					{
						data: [120, 200],
						type: 'bar',
						barWidth: 22,
						showBackground: true,
						backgroundStyle: {
							color: 'rgba(180, 180, 180, 0.2)',
						},
					},
				],
			};

			let type = 1;
			api.getGeneralViewData(type).then((res) => {
				option.xAxis.data = res.data.xList;
				option.series[0].data = res.data.yList;
				this.title1 = res.data.title;
				option.tooltip.formatter =
					'{b}： {c}' + (res.data.unitName ? res.data.unitName : '');
				option && myChart.setOption(option);
			});
		},
		fetchData2() {
			var app = {};

			var chartDom = document.getElementById('m4_info_echarts_box2');
			var myChart = echarts.init(chartDom);
			var option;

			const posList = [
				'left',
				'right',
				'top',
				'bottom',
				'inside',
				'insideTop',
				'insideLeft',
				'insideRight',
				'insideBottom',
				'insideTopLeft',
				'insideTopRight',
				'insideBottomLeft',
				'insideBottomRight',
			];
			app.configParameters = {
				rotate: {
					min: -90,
					max: 90,
				},
				align: {
					options: {
						left: 'left',
						center: 'center',
						right: 'right',
					},
				},
				verticalAlign: {
					options: {
						top: 'top',
						middle: 'middle',
						bottom: 'bottom',
					},
				},
				position: {
					options: posList.reduce(function(map, pos) {
						map[pos] = pos;
						return map;
					}, {}),
				},
				distance: {
					min: 0,
					max: 100,
				},
			};
			app.config = {
				rotate: 90,
				align: 'left',
				verticalAlign: 'middle',
				position: 'insideBottom',
				distance: 15,
				onChange: function() {
					const labelOption = {
						rotate: app.config.rotate,
						align: app.config.align,
						verticalAlign: app.config.verticalAlign,
						position: app.config.position,
						distance: app.config.distance,
					};
					// myChart.setOption({
					//     series: [
					//         {
					//             label: labelOption
					//         },
					//         {
					//             label: labelOption
					//         },
					//         {
					//             label: labelOption
					//         },
					//         {
					//             label: labelOption
					//         }
					//     ]
					// });
				},
			};
			const labelOption = {
				show: true,
				position: app.config.position,
				distance: app.config.distance,
				align: app.config.align,
				verticalAlign: app.config.verticalAlign,
				rotate: app.config.rotate,
				formatter: '{c}  {name|{a}}',
				fontSize: 16,
				rich: {
					name: {},
				},
			};
			option = {
				tooltip: {
					show: true,
					trigger: 'item',
					formatter: '{b}： {c}',
				},
				// legend: {
				//     data: ['Forest', 'Steppe', 'Desert', 'Wetland']
				// },
				// toolbox: {
				//     show: true,
				//     orient: 'vertical',
				//     left: 'right',
				//     top: 'center',
				//     feature: {
				//         mark: { show: true },
				//         dataView: { show: true, readOnly: false },
				//         magicType: { show: true, type: ['line', 'bar', 'stack'] },
				//         restore: { show: true },
				//         saveAsImage: { show: true }
				//     }
				// },

				grid: {
					left: '2%',
					right: '2%',
					bottom: '8%',
					top: '3%',
					containLabel: true,
				},
				xAxis: [
					{
						type: 'category',
						axisTick: { show: false },
						data: ['2012', '2013'],
					},
				],
				yAxis: [
					{
						type: 'value',
					},
				],
				series: [
					{
						type: 'bar',
						barGap: 0,
						emphasis: {
							focus: 'series',
						},
						color: ['#42A15B'],
						data: [320, 332],
					},
					{
						type: 'bar',
						emphasis: {
							focus: 'series',
						},
						color: ['#7D97A8'],
						data: [220, 182],
					},
				],
			};

			let type = 2;
			api.getGeneralViewData(type).then((res) => {
				option.xAxis[0].data = res.data.x;
				option.series[0].data = res.data.y1;
				option.series[1].data = res.data.y2;
				this.title2 = res.data.title;
				option.tooltip.formatter =
					'{b}： {c}' + (res.data.unitName ? res.data.unitName : '');
				option && myChart.setOption(option);
			});
		},
		fetchData3() {
			var chartDom = document.getElementById('m4_info_echarts_box3');
			var myChart = echarts.init(chartDom);
			var option;

			option = {
				color: ['#42A15B'],
				grid: {
					left: '2%',
					right: '2%',
					bottom: '6%',
					top: '12%',
					containLabel: true,
				},
				tooltip: {
					show: true,
					trigger: 'item',
					formatter: '{b}： {c}',
				},
				xAxis: {
					type: 'category',
					data: ['Mon', 'Tue'],
					axisLine: {
						lineStyle: {
							color: '#CCCCCC',
							width: 1, //这里是为了突出显示加上的
						},
					},
					axisLabel: {
						// X轴线 标签修改
						textStyle: {
							color: '#4D4D4D', //坐标值得具体的颜色
						},
					},
				},
				yAxis: {
					type: 'value',
					axisLine: {
						lineStyle: {
							color: '#CCCCCC',
							width: 1, //这里是为了突出显示加上的
						},
					},
					axisLabel: {
						// X轴线 标签修改
						textStyle: {
							color: '#4D4D4D', //坐标值得具体的颜色
						},
					},
				},
				series: [
					{
						data: [820, 932],
						type: 'line',
						smooth: true,
					},
				],
			};

			let type = 3;
			api.getGeneralViewData(type).then((res) => {
				option.xAxis.data = res.data.xList;
				option.series[0].data = res.data.yList;
				this.title3 = res.data.title;
				option.tooltip.formatter =
					'{b}： {c}' + (res.data.unitName ? res.data.unitName : '');
				option && myChart.setOption(option);
			});
		},
		fetchData4() {
			var chartDom = document.getElementById('m4_info_echarts_box4');
			var myChart = echarts.init(chartDom);
			var option;

			option = {
				color: ['#7D97A8'],
				grid: {
					left: '2%',
					right: '2%',
					bottom: '6%',
					top: '12%',
					containLabel: true,
				},
				tooltip: {
					show: true,
					trigger: 'item',
					formatter: '{b}： {c}',
				},
				xAxis: {
					type: 'category',
					data: ['英国1', '英国2'],
					axisLine: {
						lineStyle: {
							color: '#CCCCCC',
							width: 1, //这里是为了突出显示加上的
						},
					},
					axisLabel: {
						// X轴线 标签修改
						textStyle: {
							color: '#4D4D4D', //坐标值得具体的颜色
						},
					},
					splitLine: {
						show: true, // X轴线 颜色类型的修改
						lineStyle: {
							type: 'dashed',
							color: '#F2F2F2',
						},
					},
				},
				yAxis: {
					type: 'value',
					axisLine: {
						lineStyle: {
							color: '#CCCCCC',
							width: 1, //这里是为了突出显示加上的
						},
					},
					axisLabel: {
						// X轴线 标签修改
						textStyle: {
							color: '#4D4D4D', //坐标值得具体的颜色
						},
					},
					splitLine: {
						show: true, // X轴线 颜色类型的修改
						lineStyle: {
							type: 'dashed',
							color: '#F2F2F2',
						},
					},
				},
				series: [
					{
						data: [120, 200],
						type: 'bar',
						barWidth: 14,
						showBackground: true,
						backgroundStyle: {
							color: 'rgba(180, 180, 180, 0.2)',
						},
					},
				],
			};

			let type = 4;
			api.getGeneralViewData(type).then((res) => {
				option.xAxis.data = res.data.xList;
				option.series[0].data = res.data.yList;
				this.title4 = res.data.title;
				option.tooltip.formatter =
					'{b}： {c}' + (res.data.unitName ? res.data.unitName : '');
				option && myChart.setOption(option);
			});
		},
		fetchData5() {
			var chartDom = document.getElementById('m4_info_echarts_box5');
			var myChart = echarts.init(chartDom);
			var option;

			option = {
				color: ['#42A15B'],
				grid: {
					left: '2%',
					right: '2%',
					bottom: '6%',
					top: '12%',
					containLabel: true,
				},
				tooltip: {
					show: true,
					trigger: 'item',
					formatter: '{b}： {c}',
				},
				xAxis: {
					type: 'category',
					data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
					axisLine: {
						lineStyle: {
							color: '#CCCCCC',
							width: 1, //这里是为了突出显示加上的
						},
					},
					axisLabel: {
						// X轴线 标签修改
						textStyle: {
							color: '#4D4D4D', //坐标值得具体的颜色
						},
					},
				},
				yAxis: {
					type: 'value',
					axisLine: {
						lineStyle: {
							color: '#CCCCCC',
							width: 1, //这里是为了突出显示加上的
						},
					},
					axisLabel: {
						// X轴线 标签修改
						textStyle: {
							color: '#4D4D4D', //坐标值得具体的颜色
						},
					},
				},
				series: [
					{
						data: [820, 932, 901, 934, 1290, 1330, 1320],
						type: 'line',
						smooth: true,
					},
				],
			};

			let type = 5;
			api.getGeneralViewData(type).then((res) => {
				option.xAxis.data = res.data.xList;
				option.series[0].data = res.data.yList;
				this.title5 = res.data.title;
				option.tooltip.formatter =
					'{b}： {c}' + (res.data.unitName ? res.data.unitName : '');
				option && myChart.setOption(option);
			});
		},
		fetchData6() {
			var chartDom = document.getElementById('m4_info_echarts_box6');
			var myChart = echarts.init(chartDom);
			var option;

			option = {
				color: ['#7D97A8'],
				grid: {
					left: '2%',
					right: '2%',
					bottom: '6%',
					top: '12%',
					containLabel: true,
				},
				tooltip: {
					show: true,
					trigger: 'item',
					formatter: '{b}： {c}',
				},
				xAxis: {
					type: 'category',
					data: ['英国1', '英国2'],
					axisLine: {
						lineStyle: {
							color: '#CCCCCC',
							width: 1, //这里是为了突出显示加上的
						},
					},
					axisLabel: {
						// X轴线 标签修改
						textStyle: {
							color: '#4D4D4D', //坐标值得具体的颜色
						},
					},
					splitLine: {
						show: true, // X轴线 颜色类型的修改
						lineStyle: {
							type: 'dashed',
							color: '#F2F2F2',
						},
					},
				},
				yAxis: {
					type: 'value',
					axisLine: {
						lineStyle: {
							color: '#CCCCCC',
							width: 1, //这里是为了突出显示加上的
						},
					},
					axisLabel: {
						// X轴线 标签修改
						textStyle: {
							color: '#4D4D4D', //坐标值得具体的颜色
						},
					},
					splitLine: {
						show: true, // X轴线 颜色类型的修改
						lineStyle: {
							type: 'dashed',
							color: '#F2F2F2',
						},
					},
				},
				series: [
					{
						data: [120, 200],
						type: 'bar',
						barWidth: 14,
						showBackground: true,
						backgroundStyle: {
							color: 'rgba(180, 180, 180, 0.2)',
						},
					},
				],
			};

			let type = 6;
			api.getGeneralViewData(type).then((res) => {
				option.xAxis.data = res.data.xList;
				option.series[0].data = res.data.yList;
				this.title6 = res.data.title;
				option.tooltip.formatter =
					'{b}： {c}' + (res.data.unitName ? res.data.unitName : '');
				option && myChart.setOption(option);
			});
		},
		fetchData7() {
			var chartDom = document.getElementById('m4_info_echarts_box7');
			var myChart = echarts.init(chartDom);
			var option;

			option = {
				color: ['#42A15B'],
				grid: {
					left: '2%',
					right: '2%',
					bottom: '6%',
					top: '12%',
					containLabel: true,
				},
				tooltip: {
					show: true,
					trigger: 'item',
					formatter: '{b}： {c}',
				},
				xAxis: {
					type: 'category',
					data: ['Mon', 'Tue'],
					axisLine: {
						lineStyle: {
							color: '#CCCCCC',
							width: 1, //这里是为了突出显示加上的
						},
					},
					axisLabel: {
						// X轴线 标签修改
						textStyle: {
							color: '#4D4D4D', //坐标值得具体的颜色
						},
					},
				},
				yAxis: {
					type: 'value',
					axisLine: {
						lineStyle: {
							color: '#CCCCCC',
							width: 1, //这里是为了突出显示加上的
						},
					},
					axisLabel: {
						// X轴线 标签修改
						textStyle: {
							color: '#4D4D4D', //坐标值得具体的颜色
						},
					},
				},
				series: [
					{
						data: [820, 932],
						type: 'line',
						smooth: true,
					},
				],
			};

			let type = 7;
			api.getGeneralViewData(type).then((res) => {
				option.xAxis.data = res.data.xList;
				option.series[0].data = res.data.yList;
				this.title7 = res.data.title;
				option.tooltip.formatter =
					'{b}： {c}' + (res.data.unitName ? res.data.unitName : '');
				option && myChart.setOption(option);
			});
		},
		fetchData8() {
			var chartDom = document.getElementById('m4_info_echarts_box8');
			var myChart = echarts.init(chartDom);
			var option;

			option = {
				color: ['#42A15B'],
				grid: {
					left: '2%',
					right: '2%',
					bottom: '6%',
					top: '12%',
					containLabel: true,
				},
				tooltip: {
					show: true,
					trigger: 'item',
					formatter: '{b}： {c}',
				},
				xAxis: {
					type: 'category',
					data: ['Mon', 'Tue'],
					axisLine: {
						lineStyle: {
							color: '#CCCCCC',
							width: 1, //这里是为了突出显示加上的
						},
					},
					axisLabel: {
						// X轴线 标签修改
						textStyle: {
							color: '#4D4D4D', //坐标值得具体的颜色
						},
					},
				},
				yAxis: {
					type: 'value',
					axisLine: {
						lineStyle: {
							color: '#CCCCCC',
							width: 1, //这里是为了突出显示加上的
						},
					},
					axisLabel: {
						// X轴线 标签修改
						textStyle: {
							color: '#4D4D4D', //坐标值得具体的颜色
						},
					},
				},
				series: [
					{
						data: [820, 932],
						type: 'line',
						smooth: true,
					},
				],
			};

			let type = 8;
			api.getGeneralViewData(type).then((res) => {
				option.xAxis.data = res.data.xList;
				option.series[0].data = res.data.yList;
				this.title8 = res.data.title;
				option.tooltip.formatter =
					'{b}： {c}' + (res.data.unitName ? res.data.unitName : '');
				option && myChart.setOption(option);
			});
		},
		fetchData9() {
			var chartDom = document.getElementById('m4_info_echarts_box9');
			var myChart = echarts.init(chartDom);
			var option;

			option = {
				color: ['#42A15B'],
				grid: {
					left: '2%',
					right: '2%',
					bottom: '6%',
					top: '12%',
					containLabel: true,
				},
				tooltip: {
					show: true,
					trigger: 'item',
					formatter: '{b}： {c}',
				},
				xAxis: {
					type: 'category',
					data: ['Mon', 'Tue'],
					axisLine: {
						lineStyle: {
							color: '#CCCCCC',
							width: 1, //这里是为了突出显示加上的
						},
					},
					axisLabel: {
						// X轴线 标签修改
						textStyle: {
							color: '#4D4D4D', //坐标值得具体的颜色
						},
					},
				},
				yAxis: {
					type: 'value',
					axisLine: {
						lineStyle: {
							color: '#CCCCCC',
							width: 1, //这里是为了突出显示加上的
						},
					},
					axisLabel: {
						// X轴线 标签修改
						textStyle: {
							color: '#4D4D4D', //坐标值得具体的颜色
						},
					},
				},
				series: [
					{
						data: [820, 932],
						type: 'line',
						smooth: true,
					},
				],
			};

			let type = 9;
			api.getGeneralViewData(type).then((res) => {
				option.xAxis.data = res.data.xList;
				option.series[0].data = res.data.yList;
				this.title9 = res.data.title;
				option.tooltip.formatter =
					'{b}： {c}' + (res.data.unitName ? res.data.unitName : '');
				option && myChart.setOption(option);
			});
		},
		fetchData10() {
			var chartDom = document.getElementById('m4_info_echarts_box10');
			var myChart = echarts.init(chartDom);
			var option;

			option = {
				color: ['#7D97A8'],
				grid: {
					left: '2%',
					right: '2%',
					bottom: '6%',
					top: '12%',
					containLabel: true,
				},
				tooltip: {
					show: true,
					trigger: 'item',
					formatter: '{b}： {c}',
				},
				xAxis: {
					type: 'category',
					data: ['英国1', '英国2'],
					axisLine: {
						lineStyle: {
							color: '#CCCCCC',
							width: 1, //这里是为了突出显示加上的
						},
					},
					axisLabel: {
						// X轴线 标签修改
						textStyle: {
							color: '#4D4D4D', //坐标值得具体的颜色
						},
					},
					splitLine: {
						show: true, // X轴线 颜色类型的修改
						lineStyle: {
							type: 'dashed',
							color: '#F2F2F2',
						},
					},
				},
				yAxis: {
					type: 'value',
					axisLine: {
						lineStyle: {
							color: '#CCCCCC',
							width: 1, //这里是为了突出显示加上的
						},
					},
					axisLabel: {
						// X轴线 标签修改
						textStyle: {
							color: '#4D4D4D', //坐标值得具体的颜色
						},
					},
					splitLine: {
						show: true, // X轴线 颜色类型的修改
						lineStyle: {
							type: 'dashed',
							color: '#F2F2F2',
						},
					},
				},
				series: [
					{
						data: [120, 200],
						type: 'bar',
						barWidth: 14,
						showBackground: true,
						backgroundStyle: {
							color: 'rgba(180, 180, 180, 0.2)',
						},
					},
				],
			};

			let type = 10;
			api.getGeneralViewData(type).then((res) => {
				option.xAxis.data = res.data.xList;
				option.series[0].data = res.data.yList;
				this.title10 = res.data.title;
				option.tooltip.formatter =
					'{b}： {c}' + (res.data.unitName ? res.data.unitName : '');
				option && myChart.setOption(option);
			});
		},
		fetchData11() {
			var chartDom = document.getElementById('m4_info_echarts_box11');
			var myChart = echarts.init(chartDom);
			var option;

			option = {
				color: ['#7D97A8'],
				grid: {
					left: '2%',
					right: '2%',
					bottom: '6%',
					top: '12%',
					containLabel: true,
				},
				tooltip: {
					show: true,
					trigger: 'item',
					formatter: '{b}： {c}',
				},
				xAxis: {
					type: 'category',
					data: ['英国1', '英国2'],
					axisLine: {
						lineStyle: {
							color: '#CCCCCC',
							width: 1, //这里是为了突出显示加上的
						},
					},
					axisLabel: {
						// X轴线 标签修改
						textStyle: {
							color: '#4D4D4D', //坐标值得具体的颜色
						},
					},
					splitLine: {
						show: true, // X轴线 颜色类型的修改
						lineStyle: {
							type: 'dashed',
							color: '#F2F2F2',
						},
					},
				},
				yAxis: {
					type: 'value',
					axisLine: {
						lineStyle: {
							color: '#CCCCCC',
							width: 1, //这里是为了突出显示加上的
						},
					},
					axisLabel: {
						// X轴线 标签修改
						textStyle: {
							color: '#4D4D4D', //坐标值得具体的颜色
						},
					},
					splitLine: {
						show: true, // X轴线 颜色类型的修改
						lineStyle: {
							type: 'dashed',
							color: '#F2F2F2',
						},
					},
				},
				series: [
					{
						data: [120, 200],
						type: 'bar',
						barWidth: 14,
						showBackground: true,
						backgroundStyle: {
							color: 'rgba(180, 180, 180, 0.2)',
						},
					},
				],
			};

			let type = 11;
			api.getGeneralViewData(type).then((res) => {
				option.xAxis.data = res.data.xList;
				option.series[0].data = res.data.yList;
				this.title11 = res.data.title;
				option.tooltip.formatter =
					'{b}： {c}' + (res.data.unitName ? res.data.unitName : '');
				option && myChart.setOption(option);
			});
		},
		fetchData12() {
			var chartDom = document.getElementById('m4_info_echarts_box12');
			var myChart = echarts.init(chartDom);
			var option;

			option = {
				color: ['#7D97A8'],
				grid: {
					left: '2%',
					right: '2%',
					bottom: '6%',
					top: '12%',
					containLabel: true,
				},
				tooltip: {
					show: true,
					trigger: 'item',
					formatter: '{b}： {c}',
				},
				xAxis: {
					type: 'category',
					data: ['英国1', '英国2'],
					axisLine: {
						lineStyle: {
							color: '#CCCCCC',
							width: 1, //这里是为了突出显示加上的
						},
					},
					axisLabel: {
						// X轴线 标签修改
						textStyle: {
							color: '#4D4D4D', //坐标值得具体的颜色
						},
					},
					splitLine: {
						show: true, // X轴线 颜色类型的修改
						lineStyle: {
							type: 'dashed',
							color: '#F2F2F2',
						},
					},
				},
				yAxis: {
					type: 'value',
					axisLine: {
						lineStyle: {
							color: '#CCCCCC',
							width: 1, //这里是为了突出显示加上的
						},
					},
					axisLabel: {
						// X轴线 标签修改
						textStyle: {
							color: '#4D4D4D', //坐标值得具体的颜色
						},
					},
					splitLine: {
						show: true, // X轴线 颜色类型的修改
						lineStyle: {
							type: 'dashed',
							color: '#F2F2F2',
						},
					},
				},
				series: [
					{
						data: [120, 200],
						type: 'bar',
						barWidth: 14,
						showBackground: true,
						backgroundStyle: {
							color: 'rgba(180, 180, 180, 0.2)',
						},
					},
				],
			};

			let type = 12;
			api.getGeneralViewData(type).then((res) => {
				option.xAxis.data = res.data.xList;
				option.series[0].data = res.data.yList;
				this.title12 = res.data.title;
				option.tooltip.formatter =
					'{b}： {c}' + (res.data.unitName ? res.data.unitName : '');
				option && myChart.setOption(option);
			});
		},
		//获取数据列表
		fetchDataList(_uid) {
			let type = 1;
			api.getGeneralViewData(type).then((res) => {
				//console.log(res, 'list');
			});
		},
	},
	filters: {},
};
</script>
<style scoped lang="less">
.model4 {
	width: 890px;
	height: 100%;
	overflow: hidden;
	padding: 14px 30px;
	background: #fff;
}
.m4_info_box {
	width: 100%;
	// height: 1002px;
	overflow: hidden;
	margin-top: 30px;
	margin-bottom: 20px;
}
.m4_info_box1 {
	width: 390px;
	height: 100%;
	float: left;
	overflow: hidden;
}
.article_l_title {
	width: 100%;
	height: 32px;
	line-height: 32px;
	overflow: hidden;
	border-bottom: 1px solid #e6e6e6;
	margin-top: 20px;
}
.article_l_title .img1 {
	width: 3px;
	display: inline-block;
	margin-right: 7px;
	float: left;
}
.article_l_title span {
	font-size: 16px;
	font-family: Source Han Sans CN;
	font-weight: 500;
	color: #222222;
	float: left;
	display: inline-block;
	line-height: 1;
}
.article_l_more {
	height: 16px;
	line-height: 1;
	float: right;
	cursor: pointer;
	font-size: 14px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #808080;
}
.article_l_more img {
	margin-left: 2px !important;
}
.m4_info_echarts_box1 {
	width: 100%;
	height: 380px;
	margin-top: 22px;
}

.m4_info_box2 {
	width: 390px;
	height: 100%;
	float: right;
}
.m4_info_echarts_box2 {
	width: 100%;
	height: 206px;
}
.m4_info_box_big {
	width: 100%;
	height: 436px;
	overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/mode4.vue